import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_REDIRECTION_BY_LISTING_ID,
} from 'api/actionTypes';

export default async function getRedirectionByListingId({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'redirectionById', listingId];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_REDIRECTION_BY_LISTING_ID,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(redirection) {
      state.set(statePath, redirection);
    },
  });
}
